import Opportunity from '../views/opportunities/Opportunity.vue'

export default [{
    path: '/opportunities/:opportunityId',
    meta: {
        title: 'Opportunities'
    },
    component: Opportunity
}]
